import React from 'react';
import PropTypes from 'prop-types';
import { PageHeader } from '@opendate-app/setlist';

const SetlistPageHeaderApp = ({ title, supportingText }) => (
  <div className="mb-3">
    <PageHeader title={title} supportingText={supportingText} />
  </div>
);

SetlistPageHeaderApp.propTypes = {
  title: PropTypes.string.isRequired,
  supportingText: PropTypes.string,
};

export default SetlistPageHeaderApp;
